export const getFileHeaders = () => ({
  'content-type': 'multipart/form-data',
});
